// extracted by mini-css-extract-plugin
module.exports = {"fixed-actions":"fixed-container_fixed-actions__BUVMI"};